import React, { useEffect, useRef } from 'react';
import { useSphere } from 'use-cannon';
import { useThree, useFrame } from 'react-three-fiber';
import { FPVControls } from './FPVControls';
import { useKeyboardControls } from '../hooks/useKeyboardControls';
import { Vector3 } from 'three';

const SPEED = 6;

export const Player = ({sendStarted, socketRef, peersRef, ...props}) => {
  const { camera } = useThree();
  const {
    moveForward,
    moveBackward,
    moveLeft,
    moveRight,
    jump,
  } = useKeyboardControls();
  const [ref, api] = useSphere(() => ({
    mass: 1,
    type: 'Dynamic',
    ...props,
  }));

  const velocity = useRef([0, 0, 0]);
  useEffect(() => {
    api.velocity.subscribe((v) => (velocity.current = v));
  }, [api.velocity]);

  useEffect(() => {
    if(props.listenerForPA !== undefined && props.listenerForPA !== null) {
      console.info("adding player listener")
      camera.add(props.listenerForPA);
    }
  }, [props.listenerForPA])

  var frameCounterForUpdate = 0;

  useFrame(() => {
    camera.position.copy(ref.current.position);
    const direction = new Vector3();

    const frontVector = new Vector3(
      0,
      0,
      (moveBackward ? 1 : 0) - (moveForward ? 1 : 0),
    );
    const sideVector = new Vector3(
      (moveLeft ? 1 : 0) - (moveRight ? 1 : 0),
      0,
      0,
    );
    const yVector = new Vector3(
      0,
      1,
      0
    );

    direction
      .subVectors(frontVector, sideVector)
      .normalize()
      .multiplyScalar(SPEED)
      .applyEuler(camera.rotation);

    api.velocity.set(direction.x, direction.y, direction.z);

    if(sendStarted && peersRef.current && frameCounterForUpdate % 1 === 0) {
      for (let i = 0; i < peersRef.current.length; i++) {
        try {
          peersRef.current[i].peer.send(JSON.stringify({type: "move", senderID: socketRef.current.id, position: camera.position, rotation: camera.rotation}));
        } catch (error) {}
      }

      // socketRef.current.emit("move", {peerID: socketRef.current.id, position: camera.position, rotation: camera.rotation})
    }

    frameCounterForUpdate = frameCounterForUpdate + 1;
  });
  return (
    <>
      <FPVControls />
      <mesh ref={ref} />
    </>
  );
};
